import {Component} from 'react'
import {connect} from 'react-redux'
import {renderRoutes} from 'react-router-config'
import PropTypes from 'prop-types'

import SearchView from '../../../Search/Components/SearchView.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'

export class PurchaserSearchViewContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool,
  }

  static defaultProps = {
    loading: true,
  }

  render() {
    const {flattenSearchObject, isAdmin, loading, location, match, searchData, searchQuery, searchRouteName} = this.props
    const offset = match?.params.offset
    const user = searchData?.results[offset] ?? null
    const title = user ? user?.fullname ?? `#${user.id}` : null

    let children = (
      <Loader visible={true} fill={false} contains={true} containsClassName="my-5">
        Recherche en cours...
      </Loader>
    )

    if (!loading && null !== user) {
      children = (
        <div className="container purchaser-container">
          <div className="row">
            <div className="mx-auto col bg-white bd-gray-200">
              {renderRoutes(this.props.route.routes, {
                currentUser: this.props.currentUser,
                flattenSearch: flattenSearchObject,
                freelance: this.props.freelance,
                results: searchData?.results?.length ? searchData.results : [],
                loading: this.props.loading,
                pagination: this.props.pagination,
                refresh: this.refresh,
                user: user,
              })}
            </div>
          </div>
        </div>
      )
    }

    return (
      <SearchView
        flattenSearchObject={flattenSearchObject}
        isAdmin={isAdmin}
        location={location}
        match={match}
        searchData={searchData}
        searchQuery={searchQuery}
        searchRouteName={searchRouteName}
        title={title}
        viewRouteName="purchasers.search.viewer"
      >
        {children}
      </SearchView>
    )
  }
}

export default connect(
  (state) => ({
    searchData: state.search,
  }),
)(PurchaserSearchViewContainer)